import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { getAllGymPlans } from "../../redux/reducers/postApiSlice";
import { commonDeleteApi } from "../../redux/reducers/deleteApiSlice";
import { delete_gym_plans } from "../../data/ApiEndpoints";
import { showConfirmAlert } from "../components-react/ReactAlert";
import {
  convertThenFormat,
  formatDateTimezon,
  formattedLongDate,
} from "../common-data/Converts";
import ModalHeadAndClose from "../payouts-wtf/common/ModalHeadAndClose";
import PaymentLinkTable from "../payment-link-system/PaymentLinkTable";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import UpdateGymPlans from "../../pages/payment-flow/update-gym-plans/UpdateGymPlans";
import CommonStructured from "../common-components/CommonStructured";
import CommonFilterStructure from "../common-components/CommonFilterStructure";
import ReactVortoxSpinner from "../common-components/ReactVortoxSpinner";
import HelmetWrapper from "../../HelmetWrapper";
import WelcomeUser from "../Open-pages/user/WelcomeUser";
import Notifications from "../push-notifications/Notifications";
import { isAprovalAllowedEmail } from "../common-data/Accessibles";
import { isDev } from "../common-data/Commons";

const GymPlansStructure = ({
  userInfoData,
  isCustom,
  isIOS,
  // isNotificationDenied,
}) => {
  const dispatch = useDispatch();

  const isAdmin = userInfoData?.account_type === "admin";
  const isUpdateAllowed = isDev || isAprovalAllowedEmail(userInfoData?.email);
  const isGym = userInfoData?.account_type === "gym";
  // const isClusterManager = userInfoData?.account_type === "cluster_manager";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const { loading, data, error } = useSelector((state) => state.postApi);

  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    selectedPlan: "",
    selectedTrainer: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    is_web: 1,
    is_goal: 0,
    gym_id: allFilters.selectedGym?.value || "",
    duration: allFilters.selectedPlan?.value || "",
    trainer_id: allFilters.selectedTrainer?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniPTDatas = {
    allPlans: [],
  };
  const [allDatas, setAllDatas] = useState(iniPTDatas);
  const iniModvalues = {
    isModOpen: false,
    cardName: "",
    priceDetails: [],
    description: "",
    extendableDays: [],
    planFeatures: [],
  };
  const [modValues, setModValues] = useState(iniModvalues);
  const iniPDModal = {
    isModOpen: false,
    cardName: "",
    rowData: "",
  };
  const [pdModal, setPdModal] = useState(iniPDModal);

  function onCloseModalvalues() {
    setModValues(iniModvalues);
  }

  function onClosePDModal() {
    setPdModal(iniPDModal);
  }

  function onResetFilters() {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  }

  const getGymPlans = async (requestBody) => {
    const TOKEN = userInfoData?.token || "";

    try {
      const result = await dispatch(getAllGymPlans({ requestBody, TOKEN }));

      if (result?.payload?.status) {
      } else {
        // const errorMessage = result?.payload?.message || result?.error?.message;
        // toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const handleDelete = async (filter) => {
    if (filter?.uid) {
      const handleConfirm = async () => {
        try {
          const response = await dispatch(
            commonDeleteApi({
              TOKEN: userInfoData?.token,
              endpoint: delete_gym_plans,
              queryParams: filter,
            })
          ).unwrap();

          if (response?.status) {
            toast.success(response?.message || "Deleted successfully!");
            getGymPlans(filters);
            onCloseModalvalues();
          } else {
            toast.error(response?.message || "Can not delete!");
          }
        } catch (error) {
          toast.error(error || "Failed to delete");
        }
      };

      showConfirmAlert(handleConfirm, `Are you sure, you want to delete this!`);
    } else {
      toast.error("UID required!");
    }
  };

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      gym_id: allFilters.selectedGym?.value || "",
      duration: allFilters.selectedPlan?.value || "",
      trainer_id: allFilters.selectedTrainer?.value || "",
    }));
  }, [
    allFilters.selectedGym,
    allFilters.selectedPlan,
    allFilters.selectedTrainer,
  ]);

  useEffect(() => {
    getGymPlans(filters);
  }, [filters]);

  useEffect(() => {
    if (!loading && !error && data?.status && data?.data?.length > 0) {
      setAllDatas((prevs) => ({
        ...prevs,
        allPlans: data.data,
      }));
    } else {
      setAllDatas((prevs) => ({
        ...prevs,
        allPlans: [],
      }));
    }
  }, [data, loading, error]);

  const tbColumns = [
    {
      dataField: "gym_name",
      text: "gym name",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth150">{row?.gym_name || "NA"}</span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "plan name",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.plan_name?.replace(/_/g, " ") || "NA"}
            <br />
            <small className="underline gray">{row?.plan_uid || "-"}</small>
          </span>
        );
      },
    },
    {
      dataField: "duration",
      text: "duration",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.duration || 0} Days</span>;
      },
    },
    {
      dataField: "final_sell_price",
      text: "selling price",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.final_sell_price || 0)}
          </span>
        );
      },
    },
    {
      dataField: "price_details",
      text: "price details",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data link minWidth100"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "price_details",
                rowData: row,
                priceDetails: row?.price_details,
              }))
            }
          >
            View ({row?.price_details?.length || 0})
          </span>
        );
      },
    },
    {
      dataField: "plan_features",
      text: "plan features",
      formatter: (_, row) => {
        return (
          <span
            className="tb-data link minWidth100"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "plan_features",
                planFeatures: row?.plan_features,
              }))
            }
          >
            View ({row?.plan_features?.length})
          </span>
        );
      },
    },
    {
      dataField: "description",
      text: "description",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon view"
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                cardName: "description",
                description: row?.description,
              }))
            }
            style={{
              border: "1px solid #bc0909",
              color: "#bc0909",
              borderRadius: "12px",
              cursor: "pointer",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="bi bi-view-list"
              viewBox="0 0 16 16"
            >
              <path d="M3 4.5h10a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2m0 1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM1 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 2m0 12a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13A.5.5 0 0 1 1 14" />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  const tbColumnsPD = [
    {
      dataField: "plan_price",
      text: "plan price",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.plan_price || 0)}
          </span>
        );
      },
    },
    {
      dataField: "type",
      text: "plan type",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.type?.replace(/_/g, " ") || "NA"}
          </span>
        );
      },
    },
    {
      dataField: "extend_days",
      text: "extendable days",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.extend_days || 0}</span>;
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.status || "NA"}</span>;
      },
    },
    // {
    //   dataField: "coupon",
    //   text: "coupon",
    //   formatter: (_, row) => {
    //     return <span className="tb-data">{row?.coupon || "-"}</span>;
    //   },
    // },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.date_added ? formatDateTimezon(row.date_added) : "-"}
          </span>
        );
      },
    },
    isUpdateAllowed && {
      dataField: "lead_id",
      text: "Action",
      formatter: (_, row) => (
        <div className="actionButtonContainer">
          <button
            className="actionBtn icon edit"
            onClick={() => {
              setPdModal((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                cardName: "edit",
              }));
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M3.62891 17.3603V20.3254C3.62891 20.5985 3.84349 20.8131 4.1166 20.8131H7.08175C7.20855 20.8131 7.33535 20.7643 7.42313 20.6668L18.0743 10.0254L14.4166 6.36775L3.77521 17.0091C3.67768 17.1067 3.62891 17.2237 3.62891 17.3603ZM20.9029 7.19682C20.9933 7.10658 21.065 6.9994 21.114 6.88141C21.1629 6.76341 21.1881 6.63692 21.1881 6.50918C21.1881 6.38143 21.1629 6.25495 21.114 6.13695C21.065 6.01896 20.9933 5.91177 20.9029 5.82154L18.6205 3.53915C18.5302 3.44873 18.4231 3.37699 18.3051 3.32805C18.1871 3.2791 18.0606 3.25391 17.9328 3.25391C17.8051 3.25391 17.6786 3.2791 17.5606 3.32805C17.4426 3.37699 17.3354 3.44873 17.2452 3.53915L15.4603 5.32409L19.1179 8.98176L20.9029 7.19682Z"
                fill="url(#paint0_linear_14023_4477)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_14023_4477"
                  x1="3.62891"
                  y1="11.6344"
                  x2="21.1881"
                  y2="11.6344"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0.0447915" stopColor="#B4000B" />
                  <stop offset="1" stopColor="#DD0000" />
                </linearGradient>
              </defs>
            </svg>
          </button>
          <button
            className="actionBtn icon delete"
            onClick={(e) => {
              const filters = {
                uid: row?.uid || "",
              };
              handleDelete(filters);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M8.49846 4.3041H11.4978C11.4978 3.90637 11.3398 3.52492 11.0585 3.24369C10.7773 2.96245 10.3958 2.80445 9.99811 2.80445C9.60038 2.80445 9.21893 2.96245 8.9377 3.24369C8.65646 3.52492 8.49846 3.90637 8.49846 4.3041ZM7.4987 4.3041C7.4987 3.64121 7.76203 3.00548 8.23076 2.53675C8.69949 2.06802 9.33522 1.80469 9.99811 1.80469C10.661 1.80469 11.2967 2.06802 11.7655 2.53675C12.2342 3.00548 12.4975 3.64121 12.4975 4.3041H17.4963C17.6289 4.3041 17.7561 4.35676 17.8498 4.45051C17.9435 4.54425 17.9962 4.6714 17.9962 4.80398C17.9962 4.93655 17.9435 5.0637 17.8498 5.15745C17.7561 5.25119 17.6289 5.30386 17.4963 5.30386H16.4426L15.2489 15.6454C15.1645 16.3764 14.8143 17.0509 14.265 17.5405C13.7156 18.0302 13.0054 18.3007 12.2696 18.3008H7.72664C6.99077 18.3007 6.2806 18.0302 5.73125 17.5405C5.18191 17.0509 4.83173 16.3764 4.74735 15.6454L3.55363 5.30386H2.49988C2.3673 5.30386 2.24016 5.25119 2.14641 5.15745C2.05267 5.0637 2 4.93655 2 4.80398C2 4.6714 2.05267 4.54425 2.14641 4.45051C2.24016 4.35676 2.3673 4.3041 2.49988 4.3041H7.4987ZM8.99834 8.30315C8.99834 8.17057 8.94568 8.04343 8.85193 7.94968C8.75819 7.85593 8.63104 7.80327 8.49846 7.80327C8.36588 7.80327 8.23874 7.85593 8.14499 7.94968C8.05125 8.04343 7.99858 8.17057 7.99858 8.30315V14.3017C7.99858 14.4343 8.05125 14.5615 8.14499 14.6552C8.23874 14.7489 8.36588 14.8016 8.49846 14.8016C8.63104 14.8016 8.75819 14.7489 8.85193 14.6552C8.94568 14.5615 8.99834 14.4343 8.99834 14.3017V8.30315ZM11.4978 7.80327C11.3652 7.80327 11.238 7.85593 11.1443 7.94968C11.0505 8.04343 10.9979 8.17057 10.9979 8.30315V14.3017C10.9979 14.4343 11.0505 14.5615 11.1443 14.6552C11.238 14.7489 11.3652 14.8016 11.4978 14.8016C11.6303 14.8016 11.7575 14.7489 11.8512 14.6552C11.945 14.5615 11.9976 14.4343 11.9976 14.3017V8.30315C11.9976 8.17057 11.945 8.04343 11.8512 7.94968C11.7575 7.85593 11.6303 7.80327 11.4978 7.80327Z"
                fill="black"
              />
            </svg>
          </button>
        </div>
      ),
    },
  ];

  const tbColumnsED = [
    {
      dataField: "days",
      text: "Days",
      formatter: (_, row) => {
        return (
          <span className="tb-data">{convertThenFormat(row?.days || 0)}</span>
        );
      },
    },
  ];

  const tbColumnsPF = [
    {
      dataField: "feature_name",
      text: "feature name",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.feature_name || "NA"}</span>;
      },
    },
    {
      dataField: "duration",
      text: "duration",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.duration || 0}</span>;
      },
    },
    {
      dataField: "status",
      text: "status",
      formatter: (_, row) => {
        return <span className="tb-data">{row?.status || "NA"}</span>;
      },
    },
    {
      dataField: "date_added",
      text: "date added",
      formatter: (_, row) => {
        return (
          <span className="tb-data">
            {row?.date_added ? formattedLongDate(row.date_added) : "-"}
          </span>
        );
      },
    },
  ];

  return (
    <HelmetWrapper title="WTF: Gym Plans">
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModalvalues}
        contentLabel="Gym Plans"
        ariaHideApp={false}
      >
        <div
          className={`createNewCTOModalContainer ${
            modValues.cardName === "description" ||
            modValues.cardName === "extendable_days" ||
            modValues.cardName === "plan_features"
              ? "midWidthModal"
              : modValues.cardName === "price_details" && !isAdmin
              ? "mod-width-50p"
              : ""
          }`}
        >
          {modValues.cardName === "price_details" ? (
            <CommonHeadingNBtns
              title="price details"
              onClose={onCloseModalvalues}
              btnTxt={isUpdateAllowed ? "add new plan price" : null}
              onClick={
                isUpdateAllowed
                  ? () =>
                      setPdModal((prevs) => ({
                        ...prevs,
                        isModOpen: true,
                        cardName: "add",
                        rowData: modValues.rowData,
                      }))
                  : null
              }
            />
          ) : (
            <ModalHeadAndClose
              title={`${modValues.cardName?.replace(/_/g, " ")}`}
              onClose={onCloseModalvalues}
            />
          )}

          {modValues.cardName === "price_details" ||
          modValues.cardName === "extendable_days" ||
          modValues.cardName === "plan_features" ? (
            <div className="fullWidthFlexCenter overflowAuto separatedTable">
              <PaymentLinkTable
                tableData={
                  modValues.cardName === "price_details"
                    ? modValues.priceDetails
                    : modValues.cardName === "extendable_days"
                    ? modValues.extendableDays
                    : modValues.planFeatures
                }
                tableColumns={
                  modValues.cardName === "price_details"
                    ? tbColumnsPD
                    : modValues.cardName === "extendable_days"
                    ? tbColumnsED
                    : tbColumnsPF
                }
              />
            </div>
          ) : modValues.cardName === "description" ? (
            <div className="discussionModalMessage">
              <p
                className="message"
                dangerouslySetInnerHTML={{
                  __html: modValues.description || "No Content Available",
                }}
              ></p>
            </div>
          ) : null}
        </div>
      </Modal>

      <Modal
        isOpen={pdModal.isModOpen}
        onRequestClose={onClosePDModal}
        contentLabel="Gym Plans"
        ariaHideApp={false}
      >
        <UpdateGymPlans
          userInfoData={userInfoData}
          isEdit={pdModal.cardName === "edit"}
          rowData={pdModal.rowData}
          closeModal={onClosePDModal}
          prevCloseModal={onCloseModalvalues}
          callFunction={() => getGymPlans(filters)}
        />
      </Modal>

      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        {isCustom && (
          <Row>
            <Col>
              <WelcomeUser userName={userInfoData?.name} />

              {userInfoData && !isIOS() && (
                <Notifications authData={userInfoData} />
              )}

              {/* {isNotificationDenied === "denied" && (
                <Alert variant={"danger"} className="mt30">
                  Notification permission is denied. Unable to display desktop
                  notifications.
                </Alert>
              )} */}
            </Col>
          </Row>
        )}
        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Gym Plans"}
              isReload={() => getGymPlans(filters)}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <CommonFilterStructure
              from={"gym-plans"}
              decryptedText={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="fullWidthFlexCenter overflowAuto separatedTable mt30 mb30">
              {loading ? (
                <ReactVortoxSpinner />
              ) : (
                <PaymentLinkTable
                  tableData={allDatas.allPlans}
                  tableColumns={tbColumns}
                />
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default GymPlansStructure;
